import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import FileUpload from './FileUpload';

const ClientFormDialog = ({ open, onOpenChange, client, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    logo_url: '',
    display_order: 0
  });

  useEffect(() => {
    if (client) {
      setFormData({
        name: client.name || '',
        logo_url: client.logo_url || '',
        display_order: client.display_order || 0
      });
    } else {
      setFormData({
        name: '',
        logo_url: '',
        display_order: 0
      });
    }
  }, [client, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {client ? 'Edit Client' : 'Add New Client'}
          </DialogTitle>
          <DialogDescription>
            {client 
              ? 'Update client information and logo.'
              : 'Add a new client to your portfolio.'
            }
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <div className="space-y-6 py-4">
            {/* Client Name */}
            <div className="space-y-2">
              <Label htmlFor="name" className="required">
                Client Name
              </Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="e.g., Bank ABC, PT XYZ Corp"
                required
              />
            </div>

            {/* Client Logo */}
            <div className="space-y-2">
              <FileUpload
                type="logo"
                currentFile={formData.logo_url}
                onUploadSuccess={(url) => setFormData({ ...formData, logo_url: url })}
                accept="image/*"
                label="Client Logo"
                maxSize={5}
              />
              <p className="text-xs text-gray-500">
                Upload a logo or enter a URL below
              </p>
              <Input
                placeholder="https://example.com/logo.png"
                value={formData.logo_url || ''}
                onChange={(e) => setFormData({ ...formData, logo_url: e.target.value })}
              />
            </div>

            {/* Display Order */}
            <div className="space-y-2">
              <Label htmlFor="display_order">
                Display Order
              </Label>
              <Input
                id="display_order"
                type="number"
                value={formData.display_order}
                onChange={(e) => setFormData({ ...formData, display_order: parseInt(e.target.value) || 0 })}
                placeholder="0"
                min="0"
              />
              <p className="text-xs text-gray-500">
                Lower numbers appear first (0 = highest priority)
              </p>
            </div>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              className="bg-gradient-to-r from-cyan-500 to-teal-600"
            >
              {client ? 'Update Client' : 'Add Client'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ClientFormDialog;
